
import React, { useRef } from 'react';
import { modal } from "@tsinternetsale/common";
import TranslatorManager from "ts-translate-js";
import "./modal.scss";
import { useIFrameResizeForPopup } from '../../logic/hooks/utils';
import { constant } from 'lodash';

const tr = TranslatorManager.boundTR;

interface ConfirmPopupProps {
    container: any,
    title: string,
    messagehtml?: string,
    message?: string,
    confirmLabel?: string,
    cancelLabel?: string,
    onConfirm: (e: any) => void,
    onCancel: (e: any) => void,
    children?: any
}

/// <summary>
/// Popup de confirmation (OK/Annuler) peut aussi changer le texte des boutons
/// </summary>
export function ConfirmPopup({container, confirmLabel, cancelLabel, onConfirm, onCancel, children, title, messagehtml, message}: ConfirmPopupProps) {
    const buttons = [
        { label: confirmLabel ?? tr("OK"), onClick: onConfirm, kind: "primary" },
        { label: cancelLabel ?? tr("Annuler"), onClick: onCancel }
    ];

    return ( <modal.ConfirmComponent container={container} onConfirm={onConfirm} onClose={onCancel} messagehtml={messagehtml} message={message} title={title} buttons={buttons}>{children}</modal.ConfirmComponent>);
}

interface ModalPopupProps {
    container: any,
    title: string,
    onClose?: (e: any) => void,
    showCloseButton?: boolean;
    children: any;
    popupWidth?: number;
}

/// <summary>
/// Popup d'information sans aucun bouton sert à afficher n'importe quel contenu
/// container: le container dans lequel le popup sera affiché sinon il ne sera pas inclut dans le style des intégrations
/// </summary>
export function ModalPopup({container, title, children = null, onClose = constant(null), showCloseButton = true, popupWidth = 320}: ModalPopupProps) {
    const popupEl: React.RefObject<HTMLDivElement> = useRef();

    // Mecanisme pour ajuster la taille du Iframe en fonction de la taille du popup qui est externe au du principal de notre page.
    useIFrameResizeForPopup(popupEl, 0, 80); // Add 40px top and bottom to make it look better

    return <modal.EmptyBox container={container} onClose={onClose} showCloseButton={showCloseButton} popupWidth={`${popupWidth}`}>
        <div className="ModalPopup" ref={popupEl} style={{width:popupWidth}}>
            <div className="titlePanel">
                <strong>{title}</strong>
            </div>
            <div className="contentPanel">
                {children}
            </div>
        </div>
    </modal.EmptyBox>;
}